<template>
    <b-form-select v-model="selectedState" id="state" :plain="true" :options="this.stateDDL" @change="onStateChange"></b-form-select>
</template>

<script>

import axios from "axios";

export default {
  name: "DdlStateComponent",
  props: {
    countryId: String,
    currentStateId: String
  },
  data() {
    return {
        stateDDL: [],
        selectedState: this.currentStateId
    }
  },
  watch: {
    countryId: {
      immediate: true,
      handler(newValue) {
        this.getState(newValue);
      },
    },
    currentStateId: {
      immediate: true,
      handler(newValue) {
        this.selectedState = newValue;
      },
    },
  },
  methods: {
    async getState(countryId) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        const storageName = this.$store.state.config.storageName

        // Tenta recuperar da memória
        var recoveredState = localStorage.getItem(storageName + "_STATE_" + countryId)
        if(!recoveredState) {
          await axios.get(
              this.$store.state.ws_url + "/state/ddl?countryId=" + countryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

          ).then(function(resp) {
              s.stateDDL = resp.data.obj;
              localStorage.setItem(storageName + "_STATE_" + countryId, JSON.stringify(resp.data.obj))
          })
          .catch(function(error) {
              console.log(error);
          });
        }
        else {
          s.stateDDL = JSON.parse(recoveredState)
        }
    },
    onStateChange() {
      this.$emit('state-selected', this.selectedState);
    }
   
  }
  
};

</script>
